export const STICKER_MAX_BYTES = 512000;

const ALLOWED_MIME = new Set([
	"image/webp",
	"application/octet-stream",
]);

function normalizeMime(mime) {
	return String(mime || "")
		.trim()
		.toLowerCase()
		.split(";")[0]
		.trim();
}

function extensionOf(nameOrUrl) {
	const raw = String(nameOrUrl || "").split("?")[0].split("#")[0];
	const base = raw.split("/").pop() || "";
	const idx = base.lastIndexOf(".");
	if (idx < 0) return "";
	return base.slice(idx + 1).toLowerCase();
}

/**
 * Valida figurinha para Meta/Hub: mime image/webp|application/octet-stream e <= 512KB.
 * @returns {{ ok: true } | { ok: false, reason: "empty"|"tooLarge"|"mime", mime?: string, size?: number }}
 */
export function validateStickerBytes(size, mime, fileNameOrUrl = "") {
	const bytes = Number(size) || 0;
	if (bytes <= 0) {
		return { ok: false, reason: "empty", size: bytes };
	}
	if (bytes > STICKER_MAX_BYTES) {
		return { ok: false, reason: "tooLarge", size: bytes };
	}

	const mimeNorm = normalizeMime(mime);
	const ext = extensionOf(fileNameOrUrl);

	if (ALLOWED_MIME.has(mimeNorm)) {
		return { ok: true };
	}

	// Alguns browsers/servidores não setam mime; .webp explícito ainda é aceito.
	if ((!mimeNorm || mimeNorm === "application/octet-stream") && ext === "webp") {
		return { ok: true };
	}

	if (ext === "webp" && (mimeNorm.startsWith("image/") || !mimeNorm)) {
		return { ok: true };
	}

	return {
		ok: false,
		reason: "mime",
		mime: mimeNorm || ext || "unknown",
		size: bytes,
	};
}

export function validateStickerFile(file) {
	if (!file) {
		return { ok: false, reason: "empty", size: 0 };
	}
	return validateStickerBytes(file.size, file.type, file.name);
}

export async function validateStickerUrl(url) {
	try {
		const res = await fetch(url, { method: "GET", cache: "no-store" });
		if (!res.ok) {
			throw new Error(`status ${res.status}`);
		}
		const blob = await res.blob();
		const headerMime = res.headers.get("content-type");
		return validateStickerBytes(blob.size, headerMime || blob.type, url);
	} catch {
		// CORS/rede: valida extensão no front; tamanho fica no backend.
		const ext = extensionOf(url);
		if (ext !== "webp") {
			return { ok: false, reason: "mime", mime: ext || "unknown" };
		}
		return { ok: true };
	}
}

export function stickerValidationMessage(result, t) {
	if (!result || result.ok) return "";
	if (result.reason === "empty") {
		return t("messagesInput.stickerPicker.invalidEmpty");
	}
	if (result.reason === "tooLarge") {
		return t("messagesInput.stickerPicker.invalidSize");
	}
	return t("messagesInput.stickerPicker.invalidMime");
}
